<template>

    <div class="containerBox">
        <div class="zxkc_tile">前沿文献</div>
        <div class="zxkc_content">
            <div class="zxkc_content_left">
                <div class="zxkc_content_left_item_unactive"
                    :class="type == '前沿文献' ? 'zxkc_content_left_item_active' : ''" >前沿文献
                </div>
            </div>
            <div class="zxkc_content_center"></div>
            <div class="zxkc_content_right_type2" v-if="type == '前沿文献'">
                <div  class="zxkc_content_right_ppt"  v-if="listShow.length > 0" >
                    <div class="zxkc_content_right_ppt_item" v-for="(item, index) in  listShow" >
                        <div class="zxkc_content_right_ppt_item_text">
                            <div class="zxkc_content_right_ppt_item_text_left_unactive" :class="item.active == true ? 'zxkc_content_right_ppt_item_text_left' : ''"  @mouseover="item.active = true"
                            @mouseleave="item.active = false" @click="toDetail(item)">{{ item.title }}</div>
                            <div class="zxkc_content_right_ppt_item_text_right" @click="toDetail(item)" >在线预览>></div>
                        </div>
                        <div class="zxkc_content_right_ppt_item_line">
                        </div>
                    </div>
                    <div class="el_pagination">
                        <el-pagination background layout="prev, pager, next" :page-size="9" :total="total"
                            @current-change="pageChange">
                        </el-pagination>
                    </div>
                </div>
                <div v-else
                    style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                    <img style="height: 50%; width: 40%; object-fit: cover;"  src="../images/bgk.jpg"/>
                     
                </div>
            </div>
      
        </div>

    </div>
</template>
<script>
import { url } from '../services/url'
import {
    getQywxList
} from "../services/services";
export default {
    name: 'Index',
    data() {
        return {
            type: '前沿文献',
            total: 1,
            pageSize: 9,
            pageNum: 1,
            listShow: [],
            userId:localStorage.getItem('userId'),
            getUrl: url
        }
    },
    created() {
        const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
        getQywxList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
            this.total = res.total
            this.listShow = res.rows
            console.log(res)
            loading.close()
        })
    },
    methods: {
        getQywxList(type) {
            this.pageNum = 1
            this.type = type
            getQywxList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
                this.total = res.total
                this.listShow = res.rows
                console.log(res)
                loading.close()

            }).catch(err => {
                loading.close()

            })

        },
        pageChange(e) {
            this.pageNum = e
            getKycgList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
                this.total = res.total
                this.listShow = res.rows
            }).catch(err => {

            })
        },
        toDetail(item) {
            if ((item.fileUrl == null || item.fileUrl == '') && (item.outUrl == null || item.outUrl == '')) {
                this.$notify({
                    title: '提示',
                    message: '当前没有资源',
                    duration: 2000
                });
                return

            }
            else if (item.outUrl != null && item.outUrl != '') {
                window.open(item.outUrl, "_blank")
            }
            else{
                window.open(this.getUrl + item.fileUrl, "_blank")
                // this.$router.push({
                //         path: '/ViewPpt',
                //         query: {
                //             url: this.getUrl + item.fileUrl
                //         }
                //     });
            }
        }
    },
}
</script>
<style>
/* 或者本地文件 */
@import url('../css/style.css');
</style>